module.exports = "static/assets/f6d9f33ec366a89a58b3cf0e125adf97.svg";